import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styles: [':host { display: block}'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ContentComponent {
    @Input() public contentTitle: string = '';

    @Input() public noPadding = false;
}
